import store from '~/store'

export default async (to, from, next) => {
  if (!store.getters['inhaler/selectedDevice']) {
    next({ path: '/landing' })
  } else {
    next()
  }
}
